import React, { Fragment, useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { RootStoreContext } from '../../../../App/stores/RootStore'
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { Card, Divider, Label, List, ListItem } from "semantic-ui-react";

const RequestReviewSummary: React.FC = () => {
    const rootStore = useContext(RootStoreContext)
    const { requestPriorReviewSummary } = rootStore.priorReviewSummaryStore;

    return (
        <Fragment>
            {requestPriorReviewSummary.map(([group, requestPriorReviewSummaries]) => (
                <Fragment key={group}>
                    {requestPriorReviewSummaries.map(requestPriorReviewSummary => (
                        //TODO: if this key doesnt work. fix this
                        <Fragment key={requestPriorReviewSummary.identity} >
                            <Card fluid >
                                <Card.Content>
                                    <Card.Header>
                                        Request Summary - {requestPriorReviewSummary.recommendation}
                                    </Card.Header>
                                    <Divider />
                                    <Card.Description>
                                        <List>
                                            <ListItem>
                                                <Label>Self-Certification: </Label> {requestPriorReviewSummary.selfCertification}
                                            </ListItem>
                                            <ListItem>
                                                <Label>Consent-to-Disclose: </Label> {requestPriorReviewSummary.consentToDisclose}
                                            </ListItem>
                                            <ListItem>
                                                <Label>Port LOA: </Label> {requestPriorReviewSummary.portLOA}
                                            </ListItem>
                                            <ListItem>
                                                <Label>Identity: </Label> {requestPriorReviewSummary.identity}
                                            </ListItem>
                                        </List>
                                    </Card.Description>
                                    <Divider />
                                    <Card.Header>
                                        Identity Documents
                            </Card.Header>
                                    <Divider />
                                    <Card.Description>
                                        <List>
                                            {requestPriorReviewSummary.identityDocuments.map(doc => (
                                                <ListItem key={doc.name}>
                                                    <Label>{doc.documentName}: </Label>
                                                    {doc.legible !== null ? (doc.legible === "True" ? " Legible; " : "Illegible; ") : ""}
                                                    {doc.expired !== null ? (doc.expired === "True" ? "Unexpired; " : "Expired; ") : ""}
                                                    {doc.meetsRequirements !== null ? (doc.meetsRequirements === "True" ? "Meets document requirements; " : "Does not meet document requirements; ") : ""}
                                                    {doc.name !== null ? (doc.name === "True" ? "Name Verified; " : "Name Unverified; ") : ""}
                                                    {doc.address !== null ? (doc.address === "True" ? "Address Verified; " : "Address Unverified; ") : ""}
                                                    {doc.dob !== null ? (doc.dob === "True" ? "DOB Verified" : "DOB Unverified") : ""}
                                                    {doc.documentName === "Third Party Screenshot" ? (doc.deceased === "True" ? "; User Not Deceased" : "; User Deceased") : ""}
                                                    <br />
                                                    <Label>Notes: </Label> {doc.requestReviewDocumentNotes}
                                                </ListItem>
                                            ))}
                                        </List>
                                    </Card.Description>
                                </Card.Content>
                            </Card>
                        </Fragment>
                    ))}
                </Fragment>
            ))}
        </Fragment>
    )
}
export default observer(RequestReviewSummary);